import type { ManifestMap } from '@xing-com/crate-core-assets';

export async function loadManifestMap(url: string): Promise<ManifestMap> {
  return await fetch(url).then((result) => {
    return result.json();
  });
}
